/**
 * Errors that could occur when matching transactions.
 * These are roughly sorted in a priority order.
 * i.e ManyToManyUnsupported could occur when SameSource occurs,
 * but ManyToManyUnsupported is a more critical error than SameSource.
 */
export enum MatchError {
  NoExtTxSelected,
  NoCwTxSelected,
  SameTransaction,
  ManyToManyUnsupported,
  SameSource,
}
export enum MatchUsingExternalError {
  NoExtTxSelected,
  NoCwTxSelected,
  IsCategorySupported,
  DiffCategoryTrans,
  SameSource,
  DiffTransType,
  DiffAccount,
  DiffEntryDate,
  DiffAssetId,
}

export enum MatchErrorMessage {
  SameTransaction = 'Transaction(s) are already matched for specific Transaction(s).',
  SameSource = 'Transaction is already matched for specific source.Enable Many to many matching in account config to allow this operation',
  ManyToManyUnsupported = 'Many to many matching not supported for this account',
  NoExtTxSelected = 'Select an external transaction to match',
  NoCwTxSelected = 'Select a clearwater transaction to match',
}
export enum MatchUsingExternalErrorMessage {
  NoExtTxSelected = 'Select an external transaction to match',
  NoCwTxSelected = 'Select a clearwater transaction to match',
  IsCategorySupported = 'Both the clearwater and external transaction should be either Cash or Trade.',
  DiffCategoryTrans = 'Category Should be same for both External and Clearwater transaction',
  SameSource = 'No CW transaction should be matched to same source as external transaction',
  DiffTransType = 'All CW transactions should be of same type.',
  DiffAccount = 'All CW transactions should belong to same account.',
  DiffEntryDate = 'All CW transactions should have same entry date.',
  DiffAssetId = 'All CW transactions should have same assetId.',
}
